export default __webpack_public_path__ + "static/media/best-practices.a1caf170.svg";